import React from 'react';
import './Profile.css';

const YEARLY = [
  { label: 'Total Working Days', value: '95', color: '' },
  { label: 'Days Present', value: '87', color: 'green' },
  { label: 'Days Absent', value: '3', color: 'red' },
  { label: 'Late Instances', value: '8', color: 'amber' },
  { label: 'Leaves Taken', value: '5', color: '' },
  { label: 'Attendance Rate', value: '91.6%', color: 'green', big: true },
];

export default function Profile({ employee, onLogout }) {
  const initials = employee?.full_name
    ? employee.full_name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase()
    : 'AY';

  return (
    <div className="profile-page">

      <div className="profile-hero">
        <div className="profile-avatar">{initials}</div>
        <div className="profile-name">{employee?.full_name || 'Ali Younus'}</div>
        <div className="profile-dept">{employee?.department || 'Strategic Planning & Marketing'}</div>
        <span className="profile-badge">Active Employee</span>
      </div>

      <div className="prof-section-label">Employee Details</div>
      <div className="prof-card">
        {[
          { key: 'Employee ID', val: employee?.employee_id || 'EMP-001', mono: true },
          { key: 'Department', val: employee?.department || 'Strategic Planning' },
          { key: 'Job Title', val: employee?.job_title || 'Staff' },
          { key: 'Role', val: employee?.role || 'Employee' },
        ].map((r, i) => (
          <div key={i} className="prof-row">
            <span className="prof-key">{r.key}</span>
            <span className={`prof-val ${r.mono ? 'mono' : ''}`}>{r.val}</span>
          </div>
        ))}
      </div>

      <div className="prof-section-label" style={{marginTop: 16}}>2026 Summary</div>
      <div className="prof-card">
        {YEARLY.map((y, i) => (
          <div key={i} className="prof-row">
            <span className="prof-key">{y.label}</span>
            <span className={`prof-val ${y.color} ${y.big ? 'big' : ''}`}>{y.value}</span>
          </div>
        ))}
      </div>

      <button className="logout-btn" onClick={onLogout}>
        Sign Out
      </button>

    </div>
  );
}